import moment from 'moment'

export const calculateDifference = (targetDateString) => {
  const diff = new Date() - new Date(targetDateString)
  const day = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const dayText = day ? `${day} дней` : ''
  const hoursText = hours ? `${hours} часов` : ''
  return `${dayText} ${hoursText}`
}

export const dateFormatterForPickers = (date, type) => {
  const dateToUpdate = new Date(date)
  if (type === 'from') {
    return dateToUpdate.setHours(0, 0, 0, 0)
  }
  return dateToUpdate.setHours(23, 59, 59, 999)
}

export const getDateWitchRightFormat = (day) => {
  const currentDate = moment()
  const dateFiveDaysBefore = currentDate.subtract(day, 'days')
  const dateWitchRightFormat = dateFiveDaysBefore.format(
    'YYYY-MM-DD HH:mm:ss.SSS'
  )
  return dateWitchRightFormat
}

export const formatDateWithMilliseconds = (date) =>
  date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
